import moment from 'moment';
import { SCHEDULE_IMPACT_REQUEST_STATUS } from '../../../../components/ScheduleImpactRequest/ScheduleImpactRequestDrawer/utils';
import { store } from '../../../../redux/store';
import { ScheduleImpactRequestActions } from '../../../../redux/actions/scheduleImpactRequestActions';

export const setScheduleImpactRequestItems = (scheduleImpactRequestItems) => {
  if (!scheduleImpactRequestItems) {
    return [];
  }
  const states = Object.values(SCHEDULE_IMPACT_REQUEST_STATUS);
  return states.flatMap((state) => {
    const stateItems = scheduleImpactRequestItems[state];

    if (!Array.isArray(stateItems)) {
      return [];
    }
    return stateItems.map((item) => ({
      ...item,
      status: state
    }));
  });
};

export const detectChangesDates = (backupData, currentActivities) => {
  const currentScheduleImpactRequestItems =
    store.getState().scheduleImpactRequestState?.scheduleImpactRequestItems;

  if (!backupData || !currentActivities || !currentScheduleImpactRequestItems) {
    return;
  }

  currentActivities.forEach((currentActivity) => {
    const backupActivity = backupData.find(
      (backup) => backup.id === currentActivity.id
    );
    if (!backupActivity) {
      return;
    }
    const currentStartDate = moment(currentActivity.start_date).format(
      'YYYY/MM/DD'
    );
    const backupStartDate = moment(backupActivity.start_date).format(
      'YYYY/MM/DD'
    );
    const currentEndDate = moment(currentActivity.end_date).format(
      'YYYY/MM/DD'
    );
    const backupEndDate = moment(backupActivity.end_date).format('YYYY/MM/DD');

    const startDateChanged = !moment(currentStartDate).isSame(backupStartDate);
    const endDateChanged = !moment(currentEndDate).isSame(backupEndDate);

    const durationChanged =
      currentActivity.duration !== backupActivity.duration;
    if (
      (startDateChanged || endDateChanged || durationChanged) &&
      Array.isArray(currentActivity?.pendingRequests) &&
      currentActivity?.pendingRequests?.length > 0
    ) {
      const currentScheduleImpactRequestItem =
        currentScheduleImpactRequestItems.find(
          (item) => item?.id === currentActivity?.pendingRequests?.[0]?.id
        );

      if (currentScheduleImpactRequestItem) {
        store.dispatch(
          ScheduleImpactRequestActions.setScheduleImpactRequestItem({
            ...currentScheduleImpactRequestItem,
            state: SCHEDULE_IMPACT_REQUEST_STATUS.REJECTED,
            status: SCHEDULE_IMPACT_REQUEST_STATUS.REJECTED,
            date: new Date()
          })
        );
      }
      currentActivity.pendingRequests = [];
      window.to_use_react_gantt.updateTask(currentActivity.id);
    }
  });
};
